var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Avatar',{attrs:{"name":_vm.getContextNameLong(_vm.viewContext, _vm.creator),"profile-url":_vm.creator.url,"image-url":_vm.creator.avatar_url,"clients":_vm.creator.clients,"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }